import { generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import { Button } from "@/components/ui/button/button";

type Props = {
	hotelID: string;
};

export const HeaderInner = ({ hotelID }: Props) => {
	return (
		<div className="max-w-screen-screen relative mx-auto p-4 desktop:px-12 desktop:pb-5 desktop:pt-12">
			<div className="space-y-6">
				<div className="text-sm">
					<p>・ゲストに送付されるメールの文言と、送る / 送らないを設定できます</p>
					<p>
						・プラン別にメールの文言を変えることもできます。「商品管理」内の
						<Button type="button" className="h-0 px-2" variant="link">
							<a
								href={generatePath(PATHS.HOTEL.ITEMS.PLAN.TOP, { hotelID })}
								className="gap-x-2 break-all text-link-400"
							>
								プラン編集ページ
							</a>
						</Button>
						から設定できます
					</p>
					<p>
						・リクエスト予約を承認した際のメールを編集したい場合は、右のサイドメニューのリクエスト予約ページから設定できます
					</p>
				</div>
			</div>
		</div>
	);
};
